import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import strings from '../../components/locales/';

/* Function */
import ObjGeneral from '../function/';
/* Local store */
import { localStoreFN } from '../../store/localStorage';
/* Actions */
import * as driverNfaActions from '../../actions/driver_nfa/index';
import * as accountDriverActions from '../../actions/account_driver/index.js';

/* Components */
import { Tooltip } from 'react-bootstrap';
import Header from '../../components/driver_nfa/header';
import Main from '../../components/driver_nfa/main';
import Title from '../../components/driver_nfa/title';

import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import Expired from '../expired/index';

class DriverNfa extends Component {
  constructor(props) {
    super(props);
    this.state = {
      driver: 0
    };
  }

  async componentDidMount() {
    // get the permissions to validate the view
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('nfa');
    if (permit) {
      if (this.props.setting) {
        // get the setting objects
        const obj = JSON.parse(this.props.setting.value);
        const dateStart = this.props.filters.date.fechaStartFinal || null;
        const dateEnd = this.props.filters.date.fechaEndFinal || null;
        const tags = this.props.filters.tags;
        const driver = this.props.filters.driver ? this.props.filters.driver.id : null;
        this.state.driver = driver;
        if (obj.generalSetting.views.includes('nfa')) {
          await this.props.accountDriverActions.fetchAccountDriverApi({
            dateStart,
            dateEnd,
            tags,
            seeFilter: true
          });
          await this.props.actions.fetchDriverNfaApi({ dateStart, dateEnd, tags, driver: driver });
          await this.props.actions.fetchDriverNfaTimeApi({
            dateStart,
            dateEnd,
            tags,
            driver: driver
          });
          // COUNT fetch api call
        } else {
          // not authorized
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      // not authorized
      this.props.history.push('/dashboard/authorization');
    }
  }

  handleSubmit = async obj => {
    const objDate = JSON.parse(this.props.setting.value);
    const format = this.props.language.account.date.format;

    let driver = this.state.driver;
    let driverText = null;
    if (obj.id == 'driver') {
      driver = Number.isInteger(obj.value) ? obj.value : 0;
      if (Number.isInteger(obj.value)) {
        driverText = this.props.accountDriverDatos.find(o => o.id === obj.value);
      } else {
        driverText = null;
      }
      this.setState({ driver: driver });
    }

    /* TAGS */
    const tags = ObjGeneral.getTags(obj);
    /* DATE */
    const date = ObjGeneral.getDate(obj, format);

    this.props.actions.setFilterDriverNfa({
      tags: tags,
      date: date,
      driver: driverText
    });

    await this.props.accountDriverActions.fetchAccountDriverApi({
      seeFilter: true,
      tags: tags,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal
    });
    await this.props.actions.fetchDriverNfaApi({
      tags: tags,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      driver: driver
    });
    await this.props.actions.fetchDriverNfaTimeApi({
      tags: tags,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      driver: driver
    });
  };

  componentWillUnmount() {
    this.props.actions.resetDriverNfa();
  }

  render() {
    // the setting object is obtained which we use for the configuration
    const obj = JSON.parse(this.props.setting.value);

    const setting = ObjGeneral.getSetting({
      setting: obj.driverNFA,
      filter: this.props.filter,
      general: obj.generalSetting
    });

    // condition done to see if the setting was done
    if (this.props.setting) {
      const header = (
        <Header
          handleSubmit={this.handleSubmit}
          language={this.props.language}
          filter={setting.filter}
          date={this.props.dateMax[5]}
          filters={this.props.filters}
          drivers={this.props.accountDriverDatos}
        />
      );
      let container = '';
      // condition performed for loading state of the view
      if (this.props.loadingTime || this.props.loading || this.props.accountDriverLoading) {
        container = <Loading language={this.props.language} />;
        // the 401 status of the application Expired token or unauthorized
      } else if (
        this.props.status === 401 ||
        this.props.statusTime === 401 ||
        this.props.accountDriverStatus === 401
      ) {
        container = <Expired history={this.props.history} />;
        // the status 200 of the application success
      } else if (
        this.props.status === 200 &&
        this.props.statusTime === 200 &&
        this.props.accountDriverStatus === 200
      ) {
        container = (
          <div className="main-container scroll">
            <Title language={this.props.language} />
            <Main
              time={this.props.datosTime}
              filters={this.props.filters}
              date={this.props.dateMax[5]}
              language={this.props.language}
              datos={this.props.datos}
              tooltip={this.props.language.detail_fatigue.graphToolTip}
              nfa={obj.nfa}
            />
            <Tooltip placement="top" id="pageTooltip" />
          </div>
        );
      } else if (
        this.props.status === 500 ||
        this.props.statusTime === 500 ||
        this.props.accountDriverStatus === 500
      ) {
        container = <Message message={this.props.language.error.apiError500} />;
      } else {
        container = <Message message={this.props.language.error.apiError} />;
      }
      return (
        <section className="main" onScroll={this.handleScroll}>
          {header}
          {container}
        </section>
      );
    }

    return (
      <section className="main">
        <Message message="NO Setting" />
      </section>
    );
  }
}
const mapStateToProps = state => ({
  filter: state.reducer.tags.filter,

  accountDriverDatos: state.reducer.accountDriver.datos,
  accountDriverStatus: state.reducer.accountDriver.status,
  accountDriverLoading: state.reducer.accountDriver.loading,

  setting: state.reducer.dashboard.setting,
  language: state.reducer.dashboard.language,
  dateMax: state.reducer.dashboard.dateMax,

  datos: state.reducer.driverNfa.datos,
  loading: state.reducer.driverNfa.loading,
  status: state.reducer.driverNfa.status,

  datosTime: state.reducer.driverNfa.datosTime,
  loadingTime: state.reducer.driverNfa.loadingTime,
  statusTime: state.reducer.driverNfa.statusTime,

  filters: state.reducer.driverNfa.filters
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(driverNfaActions, dispatch),
  accountDriverActions: bindActionCreators(accountDriverActions, dispatch)
});
DriverNfa.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverNfa);



// WEBPACK FOOTER //
// ./source/client/containers/driver_nfa/index.jsx